module.exports = __webpack_public_path__ + "static/media/15UN-Habitat7.1cccf3ae.jpg";